import React, { useState, useEffect } from "react";
import Box from "@mui/joy/Box";
import Card from "@mui/joy/Card";
import Grid from "@mui/joy/Grid";
import CardOverflow from "@mui/joy/CardOverflow";
import AspectRatio from "@mui/joy/AspectRatio";
import Input from "@mui/joy/Input";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from "@mui/icons-material/Facebook";
import Key from "@mui/icons-material/Key";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Alert from "@mui/joy/Alert";
import ErrorIcon from "@mui/icons-material/Error";
import HikingIcon from "@mui/icons-material/Hiking";
import ForwardIcon from "@mui/icons-material/Forward";
import Link from "@mui/joy/Link";
import "../css/login.css";

let Body = ({
  formData,
  rellenarFormulario,
  tipo,
  setTipo,
  iniciarSesion,
  loading,
}) => {
  return (
    <Box sx={{ display: "grid", gap: 2, marginTop: 1 }}>
      <Box>
        <FormControl>
          <FormLabel>Correo electrónico</FormLabel>
          <Input
            placeholder="ejemplo@correo.com"
            startDecorator={<EmailIcon />}
            type={"email"}
            value={formData.correo}
            onChange={(event) => {
              rellenarFormulario(event, "correo");
              /* setFormData((x) => ({ ...x, correo: event.target.value })); */
            }}
          />
        </FormControl>
      </Box>
      <Box>
        <FormControl>
          <FormLabel>Contraseña</FormLabel>
          <Input
            placeholder="••••••••••"
            startDecorator={<Key />}
            endDecorator={
              <RemoveRedEyeIcon
                onClick={() => {
                  if (tipo === "password") {
                    setTipo("text");
                  }
                  if (tipo === "text") {
                    setTipo("password");
                  }
                }}
              />
            }
            onChange={(event) => {
              rellenarFormulario(event, "contrasena");
            }}
            value={formData.contrasena}
            type={tipo}
          />
        </FormControl>
        <Link
          color="neutral"
          underline="none"
          level="body-sm"
          href="/olvide-mi-contrasena"
          sx={{ marginTop: "0.2rem" }}
        >
          ¿Olvidaste tu Contraseña?
        </Link>
      </Box>
      <Button
        sx={{
          marginTop: "1rem",
          backgroundColor: "#123524",
          color: "white",
          borderColor: "#123524",
          "&:hover": {
            backgroundColor: "#0f2d1e", // Un tono ligeramente más oscuro en hover
            borderColor: "#0f2d1e",
          },
        }}
        loading={loading}
        onClick={() => {
          iniciarSesion();
        }}
      >
        Iniciar Sesión
      </Button>
    </Box>
  );
};

export default function Login() {
  let [formData, setFormData] = React.useState({
    correo: "",
    contrasena: "",
  });
  let [tipo, setTipo] = React.useState("password");
  let [contenidoAlerta, setcontenidoAlerta] = React.useState({
    titulo: "",
    contenido: "",
    icono: "",
    color: "",
    decorator: "",
  });
  let [estadoalerta, setestadoAlerta] = React.useState(false);
  let [estadoboton, setestadoBoton] = React.useState(false);

  let navigate = useNavigate();

  function rellenarFormulario(x, y) {
    if (y === "correo") {
      setFormData((valoranterior) => ({
        ...valoranterior,
        correo: x.target.value,
      }));
    }
    if (y === "contrasena") {
      setFormData((valoranterior) => ({
        ...valoranterior,
        contrasena: x.target.value,
      }));
    }
  }

  let iniciarSesion = async () => {
    let datosLogin = new FormData();

    datosLogin.append("correo", formData.correo);
    datosLogin.append("contrasena", formData.contrasena);

    try {
      let login = await axios.post(
        process.env.REACT_APP_FRONTEND_URL + "/api/login",
        datosLogin,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (login.data.success === true) {
        console.log(login.data.message);
        console.log("redirigir al usuario");
        setestadoBoton(true);
        setcontenidoAlerta(() => ({
          contenido: login.data.message,
          color: "success",
          decorator: <HikingIcon />,
        }));
        setestadoAlerta(true);
        /* Guardar el token en localstorage */
        localStorage.setItem("token", login.data.token);
        /* Guardar el token en localstorage */

        // Ocultar alerta automáticamente después de 3 segundos
        setTimeout(() => setestadoAlerta(false), 3000);
        setTimeout(() => navigate("/"), 3000);
      } else {
        console.log(login.data.message);
        alert(login.data.message);
      }

      console.log(login.data.success);
    } catch (err) {
      if (err.response.status === 401) {
        setcontenidoAlerta(() => ({
          contenido: `${err.response.data.message}`,
          color: "danger",
          decorator: <ErrorIcon />,
        }));
        setestadoAlerta(true);

        // Ocultar alerta automáticamente después de 3 segundos
        setTimeout(() => setestadoAlerta(false), 3000);
      }

      /* else if (err.response.status === 500){
        console.log("Error interno del servidor")
        alert("Correo o Contraseña Incorrectos")
      }
      */
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        width: "100vw",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          height: "100vh",
          width: { md: "40vw", xs: "100vw" },
          position: "relative",
          zIndex: 2,
          alignContent: "center",

          backgroundColor: "#fbfcfe",
        }}
      >
        <Box sx={{ padding: { md: 10, xs: 3 } }}>
          <Box sx={{ marginBottom: 2, display: "grid", gap: 1 }}>
            <Box sx={{ display: "grid", justifyContent: "center" }}>
              <AspectRatio
                variant="plain"
                ratio="1"
                sx={{
                  width: "100px",
                  marginBottom: "2rem",
                  borderRadius: "12px",
                }}
              >
                <img
                  src={`${process.env.REACT_APP_FRONTEND_URL}/uploads/logo.svg`}
                  alt="logo"
                  style={{ objectFit: "contain" }}
                />
              </AspectRatio>
            </Box>

            <Typography level="h4">Iniciar Sesion</Typography>
            <Typography level="body-sm">
              Conecta con aventureros como tú y descubre experiencias al aire
              libre para vivir, explorar y compartir.
            </Typography>
            {estadoalerta && (
              <Alert
                variant="soft"
                className="notificacion"
                color={contenidoAlerta.color}
                startDecorator={contenidoAlerta.decorator}
              >
                {contenidoAlerta.contenido}
              </Alert>
            )}
            <Body
              rellenarFormulario={rellenarFormulario}
              formData={formData}
              tipo={tipo}
              setTipo={setTipo}
              iniciarSesion={iniciarSesion}
              loading={estadoboton}
            />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          height: "100vh",
          width: { md: "60vw", xs: 0 },
          display: { md: "inherit", xs: "none" },
        }}
        className="fondoIniciarSesion"
      ></Box>
    </Box>
  );
}
